import { X, Loader2, Save } from "lucide-react";

/**
 * Einheitliches Erstell-/Bearbeiten-Modal für alle CRM-Entities
 * (Künstler, Feature-Künstler, Kunden, Externe).
 *
 * Layout matches DriveArtistDetail/Contact/FeatureDetail overview tabs:
 * - 2-Spalten-Grid
 * - Icon vor Label, uppercase Tracked Label
 * - Dunkler Input mit Border, Fokus-Rot
 */
export function EntityFormModal({ title, onClose, onSubmit, busy, children, submitLabel = "Speichern" }) {
  return (
    <div className="fixed inset-0 bg-black/70 backdrop-blur-sm z-50 flex items-center justify-center p-4">
      <div className="bg-[#0A0A0A] border border-white/10 max-w-3xl w-full max-h-[92vh] overflow-y-auto">
        <div className="flex items-center justify-between px-6 py-4 border-b border-white/[0.06] sticky top-0 bg-[#0A0A0A] z-10">
          <div className="font-display font-black uppercase text-lg tracking-tight">{title}</div>
          <button onClick={onClose} data-testid="entity-modal-close" className="text-zinc-500 hover:text-white p-1"><X size={18} /></button>
        </div>
        <form onSubmit={onSubmit} className="p-6 space-y-6">
          <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
            {children}
          </div>
          <div className="flex items-center justify-end gap-3 pt-4 border-t border-white/[0.06]">
            <button
              type="button"
              onClick={onClose}
              className="text-[10px] tracking-[0.3em] uppercase font-bold text-zinc-500 hover:text-white"
            >
              Abbrechen
            </button>
            <button
              type="submit"
              disabled={busy}
              data-testid="entity-modal-submit"
              className="inline-flex items-center gap-2 bg-[#ff0033] text-white px-6 py-3 text-[10px] font-bold tracking-[0.3em] uppercase hover:shadow-[0_0_20px_rgba(255,0,51,0.5)] transition-all disabled:opacity-50"
            >
              {busy ? <Loader2 size={13} className="animate-spin" /> : <Save size={13} />}
              {busy ? "Speichere…" : submitLabel}
            </button>
          </div>
        </form>
      </div>
    </div>
  );
}

/**
 * Feld mit Icon + Uppercase-Label + dunklem Input.
 * Identisch zu Feld-Style in DriveArtistDetail.
 */
export function EntityField({ icon, label, value, onChange, type = "text", full, placeholder, required, step, testid, rows }) {
  const inputCls = "w-full bg-[#050505] border border-white/10 px-4 py-3 text-white outline-none focus:border-[#ff0033]/60 transition-colors";
  return (
    <div className={full ? "md:col-span-2" : ""}>
      <label className="block text-[10px] tracking-[0.3em] uppercase text-zinc-500 font-bold mb-2 flex items-center gap-2">
        {icon} {label}{required ? " *" : ""}
      </label>
      {rows ? (
        <textarea
          rows={rows}
          value={value ?? ""}
          onChange={(e) => onChange(e.target.value)}
          placeholder={placeholder}
          data-testid={testid}
          className={`${inputCls} resize-none`}
        />
      ) : (
        <input
          type={type}
          step={step}
          required={required}
          value={value ?? ""}
          onChange={(e) => onChange(e.target.value)}
          placeholder={placeholder}
          data-testid={testid}
          className={inputCls}
        />
      )}
    </div>
  );
}
